import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncLiveFallbackPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/LiveFallbackPage/LiveFallbackPage'
    componentImport={async () => (await import('src/pages/LiveFallbackPage/LiveFallbackPage'))}
    head={({ fetch, location, params }) => async () => {
      return {
        title: 'RIAC Live',
        description: 'Rock Island Auction Company Live Bidding Platform',
      };
    }}
    {...props}
  />
);
